import {
  Box,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from '@quillbot/design-system';
import React from 'react';

const steps = [
  {
    name: 'Find Source Material',
    desc: [
      'To cite a webpage, find and copy the website’s URL, and paste it into the left-hand search bar, making sure the source format drop-down is set to “Website”.',
      'To cite a book, try using the left-hand search bar and the title or author information, after setting the drop-down source format to “Book”.',
    ],
  },
  {
    name: 'Locate, Create, and Edit',
    desc: [
      'Once you find your source material for either type, click “Cite” for a quick-start option that will generate the full and in-text citations for you with one click.',
      'Or, you can choose “Edit”, which will take you to the citation information, where you can update or add more information before adding the reference to your Citation List.',
      'You also have the option to edit your citation entries once they are in your Citation List, so don’t fret if you choose the one-click citation maker option. Find the pencil in the top-right corner of each entry to re-open the editing window. Click the “Save Citation” button once you’ve finished, and the updated entry will appear in your list.',
    ],
  },
  {
    name: 'Choose Your Format',
    desc: [
      'When you add your first citation to your list, check to make sure the right-side drop-down citation format menu shows the citation style you need–whether that’s APA, MLA, or Chicago style.',
      'If you need to change the format for any reason, switching to another style in that menu will convert all of your saved citations into that specific citation style. What can we say? We value having a citation creator that can multitask.',
    ],
  },
  {
    name: 'Check for Missing Information',
    desc: [
      'Once you’ve added a few citations to your list, check that no “Missing information” orange tags appear on any entries. If they do, review and remediate those to make sure your citations are complete and accurate.',
    ],
  },
  {
    name: 'Draft with In-Text Citations',
    desc: [
      'As you draft your paper or essay, use the in-text citations created within each full entry in your Citation List when you mention any facts or info pulled from that source. Use the handy paper icon to copy only the information you will need for that specific type of citation.',
    ],
  },
  {
    name: 'Create & Export the Full Citation List',
    desc: [
      'When you have all of your sources added and are ready to make and export your full list of citations, use the “Export All” button at the bottom of the Citation List. Easily copy the list to your clipboard or export it to MS Word to add it to the end of your paper.',
    ],
  },
];

const StyledGrid = styled(Grid)`
  background-image: url('/images/coWriter/cg-creative-2.svg');
  background-repeat: no-repeat;
  background-position: 0% 90%;
`;

const HowCGWorks = () => (
  <StyledGrid
    container
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    position="relative"
    px="16px"
    mb="48px"
  >
    <Typography
      component="h2"
      p="56px 16px 40px"
      fontSize="30px"
      fontWeight={400}
      textAlign="center"
    >
      How Does QuillBot’s Citation Generator Work?
    </Typography>

    <Box maxWidth={750} fontSize="16px" fontWeight={400} textAlign="center">
      <Typography component="p">
        Cite for free—and get 100% accurate citations, quickly and easily. QuillBot’s Citation
        Generator can cite books and web pages in APA, MLA, and Chicago style citation formats in
        just a few clicks.
      </Typography>

      <Typography component="p" pt="10px">
        Follow the simple steps below to create, edit, and export both in-text and full citations
        for your source material.
      </Typography>
    </Box>

    <Box maxWidth={800} mt="40px">
      <Stepper orientation="vertical">
        {steps.map((step) => (
          <Step key={step.name} active>
            <StepLabel>
              <Typography fontWeight={600} fontSize="14px" letterSpacing="0.1px">
                {step.name}
              </Typography>
            </StepLabel>

            <StepContent>
              {step.desc.map((desc, j) => (
                <Typography
                  key={desc.slice(0, 15)}
                  component="p"
                  pt={j === 0 ? 0 : '8px'}
                  fontSize="12px"
                  fontWeight={400}
                  letterSpacing="0.4px"
                >
                  {desc}
                </Typography>
              ))}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  </StyledGrid>
);

export default HowCGWorks;
